module.exports = __webpack_public_path__ + "img/LaddercontrolDescribeLogo.9113be25.png";